import React from 'react';
import './Tabs.css';

const Tabs = ({ tabs, selectedTab, onSelectTab }) => {
    // Фильтруем пустые строки из массива tabs
    const filteredTabs = tabs.filter(tab => tab.trim() !== '');

    return (
        <div class='flex flex-wrap gap-[10px]'>
            {filteredTabs.map(tab => (
                <button 
                    key={tab}
                    className={`tab ${selectedTab === tab ? 'active' : ''}`}
                    onClick={() => onSelectTab(tab)}
                >
                    {tab}
                </button>
            ))}
        </div>
    );
};

export default Tabs;
